<mat-nav-list>
  @for (categoria of NAVEGACION; track categoria) {
    @if (mostrarCategoria().get(categoria.nombre)) {
      <h3 class="categoria">{{ categoria.nombre }}</h3>
      @for (pagina of categoria.paginas; track pagina) {
        <a mat-list-item *autorizacion="pagina.autorizacion" [routerLink]="pagina.url">
          <mat-icon matListItemIcon>{{ pagina.icono }}</mat-icon>
          <span matListItemTitle>{{ pagina.nombre }}</span>
        </a>
      }
    }
  }
</mat-nav-list>
